import { InjectionToken } from "@angular/core";

export const GLOBAL_APP_CONFIG = new InjectionToken("GLOBAL_APP_CONFIG");